import React from 'react';

export default function ErrorDisplay() {
  return (
    <div>
      <h3>
        Something went wrong. Please check the subreddit you entered and try
        again.
      </h3>
    </div>
  );
}
